export function getPublishedResultSessions(sessions) {
  if (!Array.isArray(sessions)) return []

  return sessions.filter((session) => Boolean(session?.resultsPublishedTs))
}

export function getResultsVisibleSessions(sessions) {
  if (!Array.isArray(sessions)) return []

  return sessions.filter(
    (session) =>
      session?.type === 'hotlap' || Boolean(session?.resultsPublishedTs),
  )
}

export function getEventResultsPublicationStatus(sessions) {
  const configuredSessions = Array.isArray(sessions)
    ? sessions.filter(Boolean)
    : []
  // Hotlap results are live by default and have no publication step.
  const publicationTrackedSessions = configuredSessions.filter(
    (session) => session.type !== 'hotlap',
  )
  const publishedSessions = getPublishedResultSessions(
    publicationTrackedSessions,
  )
  const publishedCount = publishedSessions.length
  const availableCount = getResultsVisibleSessions(configuredSessions).length
  const totalCount = configuredSessions.length
  const publicationTrackedCount = publicationTrackedSessions.length

  return {
    publishedSessions,
    publishedCount,
    availableCount,
    totalCount,
    hasPublishedResults: publishedCount > 0,
    isFullyPublished:
      publicationTrackedCount > 0 &&
      publishedCount === publicationTrackedCount,
    isPartiallyPublished:
      publishedCount > 0 && publishedCount < publicationTrackedCount,
  }
}

export function getEventViewButtonState({
  eventHref,
  isAfterFinished,
  isSingleEvent,
  sessions,
}) {
  const { hasPublishedResults } = getEventResultsPublicationStatus(sessions)
  const showResults = Boolean(isAfterFinished && hasPublishedResults)

  return {
    showResults,
    label: showResults ? 'View Results' : 'View Event',
    href:
      showResults && isSingleEvent
        ? `${eventHref}?tabName=Standings`
        : eventHref,
  }
}

export function getResultsVisibleEvents(
  events,
  { includeUnpublished = false } = {},
) {
  if (!Array.isArray(events)) return []
  if (includeUnpublished) return events

  return events.flatMap((event) => {
    const visibleSessions = getResultsVisibleSessions(event?.sessions)

    return visibleSessions.length > 0
      ? [{ ...event, sessions: visibleSessions }]
      : []
  })
}

export function getStandingsEventLabel(event, index, eventCount) {
  const roundNumber = event?.eventRoundNumber ?? eventCount - index

  return `Event ${roundNumber}: ${event.name}`
}

export function getStandingsSessionRaceNumber(sessions, sessionId) {
  if (!Array.isArray(sessions) || !sessionId) return null

  const raceSessions = sessions.filter((session) => session?.type === 'race')
  if (raceSessions.length <= 1) return null

  const raceIndex = raceSessions.findIndex((session) => session.id === sessionId)

  return raceIndex >= 0 ? raceIndex + 1 : null
}
